<div class="col-md-12 p-0 common-table-style">
  <mat-table [dataSource]="clausesSource" matSort (matSortChange)="customSortData($event)">

    <ng-container matColumnDef="Name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.clauseName }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Version">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Version</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.version }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Language">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Language</mat-header-cell>
      <mat-cell *matCellDef="let element">English</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Last Updated">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.updatedDate }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Action">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>
      <mat-cell *matCellDef="let element" class="action">
        <a mat-button color="accent" disableRipple (click)="openComparisionDialog(element)"
          matTooltip="Compare Clause {{ element.name }}" [matTooltipShowDelay]="300"
          [matTooltipHideDelay]="100">
          <ng-icon name="heroChatBubbleLeftRight"></ng-icon>
        </a>

        <a mat-button color="accent" disableRipple (click)="openComparisionDialog(element, 'log')"
          matTooltip="Audit Log {{ element.name }} Audit Log" [matTooltipShowDelay]="300"
          [matTooltipHideDelay]="100">
          <ng-icon name="heroDocumentMagnifyingGlass"></ng-icon>
        </a>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="clausesColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: clausesColumns"></mat-row>

  </mat-table>

  <ng-container *ngIf="dataLoading">
    <div class="skeleton-box">
      <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
    </div>
  </ng-container>

  <ng-container *ngIf="clausesSource.data.length === 0 && !dataLoading">
    <div class="no-data">
      <h4>No Data Found</h4>
      <p>There are no clauses available</p>
    </div>
  </ng-container>
  <mat-paginator [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>
</div>